export const BusinessTypes = {
  STORE: 1,
  RENTAL: 2,
}

export const BUSINESS_TYPE_OPTIONS = [
  { id: BusinessTypes.STORE, name: 'Магазин', help: 'Продажа со склада. Количество уменьшается навсегда.' },
  { id: BusinessTypes.RENTAL, name: 'Аренда', help: 'Товар занимают на выбранные даты и потом он снова свободен.' },
]

export function businessTypeById(typeId) {
  const id = Number(typeId) === BusinessTypes.RENTAL ? BusinessTypes.RENTAL : BusinessTypes.STORE
  return BUSINESS_TYPE_OPTIONS.find((option) => option.id === id)
}
